<script>
import axios from "axios";

export const PRINTER_TYPE_ZEBRA = "ZEBRA";
export const PRINTER_TYPE_CUSTOM = "CUSTOM";

export default {
  data() {
    return {};
  },
  mounted() {
    this.loadBrowserPrintScript();
  },
  methods: {
    async printSingleZPL(printer, zpl, index) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          await this.printZPL(printer, zpl);
          resolve();
        }, index * 500); // Delay entre impresiones para evitar conflictos
      });
    },

    async printZPL(printer, zpl = []) {
      if (printer.printer_type === PRINTER_TYPE_CUSTOM) {
        return this.printZPLViaSocket(printer, zpl);
      }
      return this.printZPLViaBrowserPrint(printer.name, zpl);
    },

    async printZPLViaSocket(printer, zpl) {
      let base = printer.printer_socket?.trim().replace(/\/+$/, "");
      if (!base) {
        this.handleError("La impresora no tiene configurado el socket de impresión.");
        return;
      }
      // Sin esquema (ej: "127.0.0.1:9100") axios lo toma como URL relativa
      // y termina pegándole al origin de la app en vez de al agente de impresión.
      if (!/^(https?:)?\/\//i.test(base)) {
        base = "http://" + base;
      }
      console.log("Request print to",base)
      
      const payload = {
        ZPL: zpl,
        IpAddress: printer.ip,
        Port: printer.port,
      };
      console.log("Request print payload",payload)
      try {
        await axios.post(base + "/print/from-zpl", payload);
      } catch (error) {
        console.error("Error al enviar ZPL al socket de impresión:", error);
        this.handleError("Error al enviar ZPL a la impresora.");
      }
    },

    printZPLViaBrowserPrint(printerName, zpl = []) {
      if (!window.BrowserPrint) {
        this.handleError("BrowserPrint no está cargado. Asegúrese de tener Zebra Browser Print instalado.");
        return;
      }

      console.log("Available BrowserPrint objects:", Object.keys(window.BrowserPrint));

      try {
        window.BrowserPrint.getLocalDevices(
          (devices) => {
            console.log("Dispositivos encontrados:", devices);

            const printer = devices.find((device) => device.name && device.name.toLowerCase().includes(printerName.toLowerCase()));

            if (!printer) {
              this.handleError(`No se encontró impresora con nombre: ${printerName}`);
              return;
            }

            console.log("Impresora encontrada:", printer);

            printer.send(
              zpl,
              () => {
                console.log("✅ ZPL enviado correctamente");
              },
              (err) => {
                console.error("Error al enviar ZPL:", err);
                this.handleError("Error al enviar ZPL a la impresora");
              }
            );
          },
          (error) => {
            console.error("Error al obtener dispositivos:", error);
            this.handleError("Error al obtener dispositivos de impresión: " + printerName);
          },
          "printer" // Filtrar solo impresoras
        );
      } catch (e) {
        console.error("Error usando BrowserPrint:", e);
        this.handleError("Ha ocurrido un error al usar BrowserPrint.");
      }
    },

    async loadBrowserPrintScript() {
      // Check if BrowserPrint is already loaded
      if (window.BrowserPrint) {
        console.log("✅ BrowserPrint already loaded");
        return;
      }

      try {
        // Create a script tag to load and execute the BrowserPrint library
        const script = document.createElement("script");
        script.type = "text/javascript";

        // Fetch the script content and execute it in global context
        const response = await fetch(new URL("@/libs/utils/BrowserPrint-3.1.250.min.js", import.meta.url));
        let scriptContent = await response.text();
        // Remove core-js imports if present
        //Nose porque agrega esos require en el script y no estan en el archivo original
        scriptContent = scriptContent.replace(/require\("core-js\/modules\/es\.json\.stringify\.js"\);?/g, '');
        scriptContent = scriptContent.replace(/require\("core-js\/modules\/esnext\.json\.parse\.js"\);?/g, '');        

        script.text = scriptContent;
        document.head.appendChild(script);

        // Wait a bit for the script to execute
        await new Promise((resolve) => setTimeout(resolve, 100));

        if (window.BrowserPrint) {
          console.log("✅ BrowserPrint script loaded successfully from local file");
        } else {
          throw new Error("BrowserPrint no se cargó correctamente en window");
        }
      } catch (error) {
        console.error("❌ Failed to load BrowserPrint script from local file:", error);

        // Fallback: try direct execution with eval
        try {
          const module = await import("@/libs/utils/BrowserPrint-3.1.250.min.js?url");
          const response = await fetch(module.default);
          const scriptContent = await response.text();

          // Execute in global context
          eval(scriptContent);

          if (window.BrowserPrint) {
            console.log("✅ BrowserPrint loaded via fallback method");
          } else {
            throw new Error("BrowserPrint fallback también falló");
          }
        } catch (fallbackError) {
          console.error("❌ Fallback also failed:", fallbackError);
          this.handleError("Error al cargar la librería de impresión");
        }
      }
    },
  },
};
</script>
